// countryCodeMap: ISO 코드 → 국가명
const countryCodeMap = {
    al: 'Albania',
    dz: 'Algeria',
    ao: 'Angola',
    ar: 'Argentina',
    am: 'Armenia',
    au: 'Australia',
    at: 'Austria',
    az: 'Azerbaijan',
    bh: 'Bahrain',
    bd: 'Bangladesh',
    by: 'Belarus',
    be: 'Belgium',
    bj: 'Benin',
    bo: 'Bolivia',
    ba: 'Bosnia and Herzegovina',
    br: 'Brazil',
    bg: 'Bulgaria',
    bf: 'Burkina Faso',
    kh: 'Cambodia',
    cm: 'Cameroon',
    ca: 'Canada',
    cl: 'Chile',
    cn: 'China',
    co: 'Colombia',
    cr: 'Costa Rica',
    ci: 'Côte d’Ivoire',
    hr: 'Croatia',
    cu: 'Cuba',
    cy: 'Cyprus',
    cz: 'Czech Republic',
    cd: 'Democratic Republic of the Congo',
    dk: 'Denmark',
    do: 'Dominican Republic',
    ec: 'Ecuador',
    eg: 'Egypt',
    sv: 'El Salvador',
    ee: 'Estonia',
    et: 'Ethiopia',
    fi: 'Finland',
    fr: 'France',
    ge: 'Georgia',
    de: 'Germany',
    gh: 'Ghana',
    gr: 'Greece',
    gt: 'Guatemala',
    ht: 'Haiti',
    hn: 'Honduras',
    hk: 'Hong Kong',
    hu: 'Hungary',
    in: 'India',
    id: 'Indonesia',
    ir: 'Iran',
    iq: 'Iraq',
    ie: 'Ireland',
    il: 'Israel',
    it: 'Italy',
    jm: 'Jamaica',
    jp: 'Japan',
    jo: 'Jordan',
    kz: 'Kazakhstan',
    ke: 'Kenya',
    kw: 'Kuwait',
    kg: 'Kyrgyzstan',
    lv: 'Latvia',
    lb: 'Lebanon',
    ly: 'Libya',
    lt: 'Lithuania',
    my: 'Malaysia',
    ml: 'Mali',
    mx: 'Mexico',
    md: 'Moldova',
    ma: 'Morocco',
    mz: 'Mozambique',
    mm: 'Myanmar',
    np: 'Nepal',
    nl: 'Netherlands',
    nz: 'New Zealand',
    ni: 'Nicaragua',
    ng: 'Nigeria',
    mk: 'North Macedonia',
    no: 'Norway',
    om: 'Oman',
    pk: 'Pakistan',
    ps: 'Palestine',
    pa: 'Panama',
    py: 'Paraguay',
    pe: 'Peru',
    ph: 'Philippines',
    pl: 'Poland',
    pt: 'Portugal',
    pr: 'Puerto Rico',
    qa: 'Qatar',
    ro: 'Romania',
    ru: 'Russia',
    sa: 'Saudi Arabia',
    sn: 'Senegal',
    rs: 'Serbia',
    sg: 'Singapore',
    sk: 'Slovakia',
    si: 'Slovenia',
    za: 'South Africa',
    kr: 'South Korea',
    es: 'Spain',
    lk: 'Sri Lanka',
    se: 'Sweden',
    ch: 'Switzerland',
    sy: 'Syria',
    tw: 'Taiwan',
    tz: 'Tanzania',
    th: 'Thailand',
    tt: 'Trinidad and Tobago',
    tn: 'Tunisia',
    tr: 'Türkiye',
    tm: 'Turkmenistan',
    ug: 'Uganda',
    ua: 'Ukraine',
    ae: 'United Arab Emirates',
    gb: 'United Kingdom',
    us: 'United States',
    uy: 'Uruguay',
    uz: 'Uzbekistan',
    ve: 'Venezuela',
    vn: 'Vietnam',
    ye: 'Yemen',
    zm: 'Zambia',
    zw: 'Zimbabwe',
};

// 국가코드 → 나라명 변환 함수
function getCountryName(code) {
    if (!code) return '';
    return countryCodeMap[code.toLowerCase()] || code;
}

export { getCountryName };
